import { useCallback, useContext, useEffect, useRef } from 'react';
import { AuthContext } from '_store';

export const useActivityFrame = () => {
    const { registerActivityFrame } = useContext(AuthContext);
    const cleanupRef = useRef(() => {});

    useEffect(() => () => cleanupRef.current(), []);

    return useCallback((frame) => {
        cleanupRef.current();
        cleanupRef.current = frame ? registerActivityFrame(frame) : () => {};
    }, [registerActivityFrame]);
};
